var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42578 9.99443V14.4993C3.42578 15.8816 4.54641 17.0019 5.92833 17.0019H8.54525L15.7517 21.7346C16.4815 22.1378 17.4753 21.3564 17.9616 20.368L5.19474 7.60156C4.17068 7.91518 3.42578 8.86737 3.42578 9.99443Z",
    fill: "#A1ABB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2533 4.84283C18.2533 3.46052 17.0019 1.54761 15.7508 2.34028L9.14453 7.07271L18.2533 16.1816V4.84283Z",
    fill: "#A1ABB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72072 7.50416L18.1387 19.9221L19.3525 21.1355C19.5749 21.3586 19.8672 21.4701 20.1592 21.4701C20.4512 21.4701 20.7435 21.3586 20.9662 21.1355C21.412 20.69 21.412 19.9673 20.9662 19.5215L18.2533 16.8085L8.77941 7.33469L4.64754 3.20372C4.42502 2.98069 4.13288 2.86914 3.84073 2.86914C3.54858 2.86914 3.25662 2.98069 3.03372 3.20372C2.58772 3.64915 2.58772 4.37193 3.03372 4.81754L5.72072 7.50416Z",
    fill: "#A1ABB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco4);
export default __webpack_public_path__ + "static/media/ico-4.df1ed42197496b16cd927e3fee22fb04.svg";
export { ForwardRef as ReactComponent };